import { InferOutput, nullable, object } from 'valibot'
import { ArmyPaintIdSchema } from './ArmyPaintId.type'
import { ArmyPaintListSchema } from './ArmyPaintList.type'

export const ArmyPaintCollectionSchema = object({
  selected: nullable(ArmyPaintIdSchema),
  data: ArmyPaintListSchema,
})

export type ArmyPaintCollection = InferOutput<typeof ArmyPaintCollectionSchema>
